angular.module('cn')

.component('cnMain', {
  template: require('./cnmain.html'),
  controller: [
    'networksRepository',
    '$uibModal',
    function(networksRepository, $uibModal) {
      var $ctrl = this;

      this.$onInit = function() {
        $ctrl.networks = [];
        networksRepository.getAll().then(function(networks) {
          $ctrl.networks = networks;
        });
      };

      this.goToCreate = function() {
        $uibModal.open({
          animation: false,
          component: 'createnetwork'
        });
      };
    }
  ]
});



// WEBPACK FOOTER //
// ./src/cn/cnmain.js